import { create } from 'zustand'
import type { Church } from '../types/church'

type State = {
  churches: Array<Church>
  add: (church: Church) => void
  update: (church: Church) => void
  remove: (_id: string) => void
  setChurches: (churches: Array<Church>) => void
}

const initial: Array<Church> = []

export const useChurchesStore = create<State>((set, get) => ({
  churches: initial,
  add: (church) => {
    set({ churches: [...get().churches, church] })
  },
  update: (church) => {
    set({
      churches: get().churches.map((x) => (x._id === church._id ? church : x)),
    })
  },
  remove: (_id) => {
    set({ churches: get().churches.filter((c) => c._id !== _id) })
  },
  setChurches: (churches) => {
    set({ churches })
  },
}))
